import { Sparkles, Hand, CheckCircle2, CornerUpLeft, Undo2, Paperclip, MessageSquare, Flag, MessageSquarePlus } from "lucide-react";
import { fmtDate } from "../lib/api";
import { FeedbackBody } from "./Feedback";

const META = {
  created: [Sparkles, "text-[#FF6B00]", () => "created the work item"],
  picked_up: [Hand, "text-orange-300", (h, s) => `picked up "${s(h.step_index)}"`],
  released: [Undo2, "text-slate-400", (h, s) => `released "${s(h.step_index)}" back to the queue`],
  completed_step: [CheckCircle2, "text-emerald-400", (h, s) => `completed "${s(h.step_index)}"${h.output_files?.length || h.output_link ? ` and handed over ${[...(h.output_files || []), h.output_link].filter(Boolean).join(", ")}${h.version > 1 ? ` (v${h.version})` : ""}` : ""}`],
  finished: [Flag, "text-emerald-300", () => "— all steps done"],
  sent_back: [CornerUpLeft, "text-rose-400", (h, s) => `sent back from "${s(h.step_index)}" to "${s(h.to_step)}"`],
  attachment: [Paperclip, "text-sky-300", (h) => `attached ${[h.file_name, h.link].filter(Boolean).join(" + ")}`],
  comment: [MessageSquare, "text-slate-300", () => "left a note"],
  feedback: [MessageSquarePlus, "text-[#FF6B00]", (h, s) => `gave feedback${h.voice_notes?.length ? ` (${h.voice_notes.length} voice note${h.voice_notes.length > 1 ? "s" : ""})` : ""} on "${s(h.step_index)}"`],
};

export const Timeline = ({ task }) => {
  const stepName = (i) => task.steps[i]?.name || `Step ${i + 1}`;
  return (
    <ol className="relative space-y-5 border-l border-[#282E3D] pl-6" data-testid="task-history-timeline">
      {[...task.history].reverse().map((h) => {
        const [Icon, color, text] = META[h.action] || [MessageSquare, "text-slate-400", () => h.action];
        return (
          <li key={h.id} className="relative" data-testid={`history-${h.action}`}>
            <span className="absolute -left-[33px] flex h-5 w-5 items-center justify-center rounded-full border border-[#282E3D] bg-[#141721]">
              <Icon className={`h-3 w-3 ${color}`} />
            </span>
            <div className="text-sm"><b className="text-slate-100">{h.user_name}</b> <span className="text-slate-400">{text(h, stepName)}</span></div>
            <FeedbackBody task={task} h={h} />
            <div className="mt-1 font-mono text-[10px] text-slate-600">{fmtDate(h.at)}</div>
          </li>
        );
      })}
    </ol>
  );
};
